/* Neyli : ajout au panier depuis les recommandations (questionnaire, suggestions du panier). */
(function () {
  if (window.neilyAddToCart) return;

  function sectionIds() {
    var cn = document.querySelector('cart-notification');
    if (!cn || typeof cn.getSectionsToRender !== 'function') return [];
    return cn.getSectionsToRender().map(function (s) { return s.id; });
  }

  function isCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function reset(btn, label) {
    if (!btn) return;
    btn.innerHTML = label;
    btn.removeAttribute('aria-disabled');
    btn.classList.remove('loading');
  }

  window.neilyAddToCart = function (variantId, btn) {
    if (!variantId) return Promise.resolve();
    var label = btn ? btn.innerHTML : '';
    if (btn) {
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      btn.textContent = 'Ajout…';
    }
    var onCart = isCartPage();
    var ids = onCart ? [] : sectionIds();
    var body = { id: Number(variantId), quantity: 1 };
    if (ids.length) {
      body.sections = ids.join(',');
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Ajout impossible pour le moment.');
        if (onCart) { window.location.reload(); return; }
        var cn = document.querySelector('cart-notification');
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'neily-reco', productVariantId: variantId, cartData: res });
        }
        if (cn && res.sections) {
          cn.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
          return;
        }
        if (btn && btn.isConnected) {
          btn.textContent = 'Ajouté ✓';
          setTimeout(function () { reset(btn, label); }, 2000);
        }
      })
      .catch(function (err) {
        reset(btn, label);
        if (!btn) return;
        var m = document.createElement('p');
        m.className = 'neily-add-error';
        m.setAttribute('role', 'alert');
        m.textContent = err.message;
        btn.insertAdjacentElement('afterend', m);
        setTimeout(function () { m.remove(); }, 6000);
      });
  };

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-neily-add]');
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-disabled') === 'true') return;
    window.neilyAddToCart(b.getAttribute('data-neily-add'), b);
  });
})();
